import React from 'react';
import LinkedCompanyCard from '../../molecules/LinkedCompanyCard/view';
import './style.css';

/**
 * LinkedCompaniesGrid Organism
 * Connects useAccountantHub with LinkedCompanyCard molecules.
 */
function LinkedCompaniesGrid({ 
    linkedCompanies = [], 
    fiscalAlerts = [], 
    handleEnterCompany, 
    handleAlertClick, 
    isLoading, 
    onOpenDrafts, 
    onAddClient 
}) {
    // Helper to find alerts for a specific company
    const getCompanyAlertData = (ownerUserId) => {
        // Handle potential type mismatch (string vs number)
        return fiscalAlerts?.find(alert => String(alert.company_id) === String(ownerUserId));
    };

    if (linkedCompanies.length === 0 && !isLoading) {
        return (
            <div className="organisms-grid">
                <div className="new-client-card" onClick={onAddClient} id="btn-add-client-empty">
                    <span className="new-client-card-icon">+</span>
                    <span className="new-client-card-text">Agregar nuevo cliente</span>
                </div>
            </div>
        );
    }

    return (
        <div className="organisms-grid">
            {linkedCompanies.map((company) => {
                const alertData = getCompanyAlertData(company.owner_user_id);

                return (
                    <LinkedCompanyCard
                        key={company.id}
                        companyName={company.owner_data?.companyName || company.owner_name || "Sin Nombre"}
                        ownerName={company.owner_data?.name || ""}
                        ownerEmail={company.owner_data?.email || company.owner_email || ""}
                        avatarUrl={company.owner_data?.url_avatar}
                        onEnter={() => handleEnterCompany && handleEnterCompany(company.owner_user_id)}
                        onAlertClick={(alertKey) => handleAlertClick && handleAlertClick(company.owner_user_id, alertKey)}
                        onOpenDrafts={() => onOpenDrafts && onOpenDrafts(company.owner_user_id)}
                        pendingDraftsCount={company.pending_drafts_count || 0}
                        isLoading={isLoading}
                        alertStatus={alertData?.status || 'green'}
                        alerts={alertData?.alerts || null}
                    />
                );
            })}
            {!isLoading && (
                <div className="new-client-card" onClick={onAddClient} id="btn-add-client-grid">
                    <span className="new-client-card-icon">+</span>
                    <span className="new-client-card-text">Agregar nuevo cliente</span>
                </div>
            )}
            {isLoading && (
                <>
                    {[1, 2, 3].map((n) => (
                        <div key={n} className="skeleton-card">
                            <div className="d-flex align-items-center gap-3">
                                <div className="skeleton-avatar skeleton-pulse" />
                                <div className="flex-grow-1">
                                    <div className="skeleton-line-title skeleton-pulse mb-2" />
                                    <div className="skeleton-line-sub skeleton-pulse" />
                                </div>
                            </div>
                            <div>
                                <div className="skeleton-line-desc skeleton-pulse" />
                            </div>
                            <div className="skeleton-buttons">
                                <div className="skeleton-button skeleton-pulse" />
                                <div className="skeleton-button skeleton-pulse" />
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
}

export default LinkedCompaniesGrid;
